<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    class="pr-0"
                    cols="5">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterBySaleNameEmailAndPhone')"/>
                </v-col>
                <v-col cols="2">
                    <v-select
                        outlined
                        hide-details
                        v-model="pagination.status"
                        v-on:change="changeStatus"
                        append-icon="expand_more"
                        height="40px"
                        item-value="value"
                        item-text="text"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="statusList"/>
                </v-col>
                <v-col cols="3">
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <sale-agent-table
                :search="pagination.search"
                :items="staffs"
                :options="pagination"
                :excludeHeaders="[
                    $constant.table.SALE_AGENT_KEY.isVerified,
                    $constant.table.SALE_AGENT_KEY.email,
                    $constant.table.SALE_AGENT_KEY.phonenumber,
                    $constant.table.SALE_AGENT_KEY.subRoles,
                    $constant.table.SALE_AGENT_KEY.totalAmount,
                    $constant.table.SALE_AGENT_KEY.totalTickets,
                    $constant.table.SALE_AGENT_KEY.createdAt,
                    $constant.table.SALE_AGENT_KEY.totalCommission
                ]"
                @viewDetails="openAndamandaStaffDetails"/>
        </v-card-text>

        <right-panel
            ref="editAndmandaStaffPanel"
            :title="$t('saleAgent.andamandaStaffDetails')">
            <template v-slot:content="{ context }">
                <sale-agent-details-view
                    ref="saleAgentDetailsView"
                    :disablerole="true"
                    :saleAgent="context"
                    @closeRightPanel="closeRightPanel"/>
            </template>

            <template v-slot:bottom>
                <button-status-field
                    :status="$constant.ACTIVE_STATUS"
                    @click="onEditStaffPanelSetActive"/>
                <button-status-field
                    class="ml-0"
                    :status="$constant.INACTIVE_STATUS"
                    @click="onEditStaffPanelSetInActive"/>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onEditStaffPanelSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </v-card>
</template>

<script>
import SaleAgentTable from '@/components/tables/SaleAgentTable'
import RightPanel from '@/components/panels/RightPanel'
import SaleAgentDetailsView from '@/views/SaleAgentDetailsView'
import ButtonStatusField from '@/components/fields/ButtonStatusField'
import { mapState } from 'vuex'

export default {
    name: 'AndamandaStaffListView',

    components: {
        SaleAgentTable,
        RightPanel,
        SaleAgentDetailsView,
        ButtonStatusField
    },
    computed: {
        ...mapState('andamandaStaffListPage', ['stafflist'])
    },
    props: {
        staffs: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            statusList: [
                this.$constant.ACTIVE_STATUS,
                this.$constant.INACTIVE_STATUS,
                this.$constant.ALL_STATUS
            ]
        }
    },

    methods: {
        openAndamandaStaffDetails (staff) {
            const cloneStaff = JSON.parse(JSON.stringify(staff))
            this.$refs.editAndmandaStaffPanel.open(cloneStaff)
        },
        closeRightPanel () {
            this.$refs.editAndmandaStaffPanel.close()
        },
        changeStatus (value) {
            var optionData = {}
            if (value === 'all status') {
                optionData = {
                    roles: 'staff',
                    isVerified: 'approve'
                }
            } else {
                optionData = {
                    roles: 'staff',
                    isVerified: 'approve',
                    isActive: value
                }
            }
            this.$store.commit('andamandaStaffListPage/setOption', optionData)
            this.$store.dispatch('andamandaStaffListPage/fetchStafflist')
        },

        onEditStaffPanelSetActive () {
            this.$refs.saleAgentDetailsView.setisActive('active')
        },

        onEditStaffPanelSetInActive () {
            this.$refs.saleAgentDetailsView.setisActive('inactive')
        },

        onEditStaffPanelSave () {
            this.$refs.saleAgentDetailsView.patchUpdate()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-select {
    .v-select__selection {
        text-transform: capitalize;
    }
}
</style>
